import React from "react";
import "./BrandSlider.css";
import Marquee from "react-fast-marquee";
const BrandSlider = ({ data, title, desc }) => {
  return (
    <>
      <div className="py-5">
        <div className="container">
          <div className="row">
            <div className="col-12 mx-auto text-center">
              <h2 className="textt-gradient bg-primary mb-0" data-aos="zoom-in">
                {desc}
              </h2>
            </div>
          </div>
          <div data-aos="fade-up">
            <Marquee>
              {data.map((item, index) => {
                return (
                  <div key={index} className="brand-slider-item">
                    <img
                      className="brand-slider-img"
                      src={`./images/${title}/${item.img}`}
                      alt="logo"
                    />
                  </div>
                );
              })}
            </Marquee>
          </div>
        </div>
      </div>
    </>
  );
};

export default BrandSlider;
